import { render } from "./CandidateLinksTab.vue?vue&type=template&id=19a6b974"
import script from "./CandidateLinksTab.vue?vue&type=script&lang=js"
export * from "./CandidateLinksTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__